import { Module } from 'vuex';

const key = 'managerTeamRequestsPageFilter';
export interface TeamRequestsStateStorable {
  filters: { status: string[]; company: string[]; search: string };
}

export const defaultTeamRequestsState: TeamRequestsStateStorable = {
  filters: {
    status: undefined,
    company: undefined,
    search: undefined
  }
};

export const teamRequests: Module<TeamRequestsStateStorable, any> = {
  namespaced: true,
  state: {
    filters: localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : defaultTeamRequestsState.filters
  },
  getters: {
    filters: state => getFiltersFromState(state)
  },
  mutations: {
    setStatusFilter(state, status: string[]) {
      const filters = getFiltersFromState(state);
      filters.status = status;
      persistFiltersState(state, filters);
    },
    setCompanyFilter(state, company: string[]) {
      const filters = getFiltersFromState(state);
      filters.company = company;
      persistFiltersState(state, filters);
    },
    setSearchFilter(state, search: string) {
      const filters = getFiltersFromState(state);
      filters.search = search;
      persistFiltersState(state, filters);
    }
  }
};

const getFiltersFromState = (state): any => {
  return Object.assign({}, state.filters);
};

const persistFiltersState = (state, filters: any) => {
  state.filters = filters;
  localStorage.setItem(key, JSON.stringify(filters));
};
